import { put, call, delay } from "redux-saga/effects";
import * as actions from "../actions";
import { getHoliday } from "../../api";
import { postHolidayRequestForm, fetchHolidayHistory } from "../../api/fontApi";

export function* requestHolidayData() {
  yield put(actions.holidaySetIsLoading(true));
  try {
    const holidayRes = yield call(getHoliday);
    const holidayHistoryRes = yield call(fetchHolidayHistory);
    if (holidayRes.status === 200 && holidayHistoryRes.status === 200) {
      if (typeof holidayRes.data === "string") {
        yield put(actions.addError("holiday", holidayRes.data));
      }
      const { holidayData } = holidayRes.data;
      const { holiday_history: holidayHistoryData } = holidayHistoryRes.data;
      yield put(actions.holidaySetData({ holidayData }));
      yield put(actions.holidayHistorySetData({ holidayHistoryData }));
    }
  } catch (err) {
    yield put(actions.addError("holiday", err));
  } finally {
    yield put(actions.holidaySetIsLoading(false));
  }
}

export function* postHolidayRequestFormSaga({ payload }) {
  yield put(actions.setHolidayRequestFormSubmitted(null));
  try {
    const { formContent } = payload;
    yield put(actions.setHolidayRequestFormLoading(true));
    const { holiday_history: holidayHistoryData } = yield call(
      postHolidayRequestForm,
      formContent
    );
    yield put(actions.holidayHistorySetData({ holidayHistoryData }));

    yield put(actions.setHolidayRequestFormLoading(false));
    yield put(actions.setHolidayRequestFormSubmitted(true));
    yield delay(3000);
    yield put(actions.setHolidayRequestFormSubmitted(null));
  } catch (error) {
    yield put(
      actions.addError("postHolidayRequest", error.response.data.message)
    );
    yield put(actions.setHolidayRequestFormSubmitted(false));
    yield put(actions.setHolidayRequestFormLoading(false));
  }
}
